
# This class presents a simple marker toolbar on the map
class L.Control.MfPolygon extends L.Control.MfButtonGrid
    constructor: () ->
        super()
        @setDefaults()
        @noTooltipButtons = true
        # by default, use only the additive polygon button
        @optionModeAll = false
        L.drawLocal.draw.handlers.rectangle.tooltip.start = 'Click or drag to draw rectangle'
        L.drawLocal.draw.handlers.circle.tooltip.start = 'Click or drag to draw circle'

    setColor: (color) =>
        @color = color

    # set default options.
    setDefaults: () =>
        @options =
            position: 'topleft'
            colors:
                style: (mode) =>
                    if @mode is 'add'
                        return {
                            color: '#008000'
                            width: 3
                            icon: { iconSize: [4, 4] }
                        }
                    if @mode is 'subtract'
                        return {
                            color: '#FF0000'
                            width: 3
                        }

            toolbars: [
                { # Box/Group
                    rows: [
                        [ # Row
                            { name: 'draw-polygon-add', html: '<i class="drawicon-poly-green"></i>', toggle: true },
                        ],
                    ]
                }
            ]

    setStealthStyling: () =>
        @options =
            position: 'topleft'
            toolbars: [
                {
                    rows: []
                }
            ]

    setAllToolOptions: () =>
        @optionModeAll = true
        @options =
            position: 'topleft'
            colors:
                style: (mode) =>
                    if @mode is 'add'
                        return {
                            color: '#008000'
                            width: 3
                            icon: { iconSize: [4, 4] }
                        }
                    if @mode is 'subtract'
                        return {
                            color: '#FF0000'
                            width: 3
                        }

            toolbars: [
                { # Box/Group
                    style: {
                        width: '66px'
                    },
                    rows: [
                        [ # Row
                            { name: 'draw-polygon-add', html: '<i class="drawicon-poly-green"></i>', toggle: true },
                            { name: 'draw-polygon-sub', html: '<i class="drawicon-poly-red"></i>', toggle: true }
                        ],
                        [
                            { name: 'draw-rect-add', html: '<i class="drawicon-rect-green"></i>', toggle: true },
                            { name: 'draw-rect-sub', html: '<i class="drawicon-rect-red"></i>', toggle: true },
                        ],
                        [
                            { name: 'draw-circle-add', html: '<i class="drawicon-circle-green"></i>', toggle: true },
                            { name: 'draw-circle-sub', html: '<i class="drawicon-circle-red"></i>', toggle: true },
                        ],
                    ]
                }
            ]


    # When the control is added to the map, register the callback and init the marker tool
    onAdd: (map) ->
        @map = map
        @mode = null
        @current_tool = null
        container = super(map)

        if @optionModeAll
            @addCallback 'draw-polygon-sub,draw-rect-sub,draw-circle-sub', @_subtractiveButtonPressed
            @addCallback 'draw-polygon-add,draw-rect-add,draw-circle-add', @_additiveButtonPressed
            @addCallback 'draw-polygon-add,draw-polygon-sub', @_drawPolygon
            @addCallback 'draw-rect-add,draw-rect-sub', @_drawRectangle
            @addCallback 'draw-circle-add,draw-circle-sub', @_drawCircle
        else
            @addCallback 'draw-polygon-add', @_drawPolygon
            @_drawPolygon()

        @map.on 'draw:created', @handleMarkerDrop
        # @selectBtn 'draw-polygon-add'

        return container

    handleMarkerDrop: (e) =>
        if @optionModeAll
            # on finish deselect all buttons, and enable all buttons
            @deselectAllButtons()
            @enableBtn 'draw-polygon-add'
            @enableBtn 'draw-polygon-sub'
            @enableBtn 'draw-rect-add'
            @enableBtn 'draw-rect-sub'
            @enableBtn 'draw-circle-add'
            @enableBtn 'draw-circle-sub'
        else
            @enableBtn 'draw-polygon-add'
            @deselectBtn 'draw-polygon-add'

        # fire an event for any external listeners
        @fire('mfpolygon:created', e)

    # Handles setting subtractive mode
    _subtractiveButtonPressed: (e, name) =>
        @mode = 'subtract'
        @fire('mfpolygon:subtractmode')

    # Handles setting additive mode
    _additiveButtonPressed: (e, name) =>
        @mode = 'add'
        @fire('mfpolygon:addmode')

    deselect: () =>
        @current_tool.disable()

    select: () =>
        @current_tool.enable()
        @fire('mfpolygon:tool_selected')

    _drawRectangle: () =>
        # $('#map_canvas').addClass('leaflet-pane')
        @current_tool =  new L.Draw.Rectangle @map, shapeOptions: (@options.colors?.style?(@mode) ? {})
        @current_tool.options.metric = false
        @current_tool.enable()
        # @fire('mfpolygon:tool_activated', 'rectangle');

    # Handle initializing a circle drawing tool
    _drawCircle: () =>
        @current_tool = new L.Draw.Circle @map, shapeOptions: (@options.colors.style(@mode) ? {})
        @current_tool.options.units = 'english'
        @current_tool.enable()

    _drawPolygon: () =>
        # since we will be using -> later, we need a reference to the current version of this
        self = this

        # these buttons are only enable once a certain number of markers have been placed
        @disableTooltipButton(@finishButton)
        @disableTooltipButton(@deletePointButton)

        # create the handler for drawing polygons
        handler = new L.Draw.NewPoly @map,
            allowIntersection: false
            shapeOptions: {
                color: 'black'
                fillColor: @color,
                weight: 5,
                dashArray: '5,10'
                opacity: 1
                fillOpacity: 0.65
            }

        # modify the options for the marker to make the first one different
        handler.options.icon.options.iconSize.x = 16
        handler.options.icon.options.iconSize.y = 16
        # # set the default classes that we want most of the markers to have
        defaultClasses = 'leaflet-marker-icon leaflet-div-icon leaflet-editing-icon leaflet-zoom-animated leaflet-clickable'
        # # set the special classes that we want the first marker to have
        handler.options.icon.options.className = 'leaflet-marker-icon custom-marker leaflet-editing-icon leaflet-zoom-animated leaflet-clickable'
        # set the cursor to crosshair when hovering leaflet markers
        $('.leaflet-marker-pane').css('cursor', 'crosshair')
        handler._onTouch = (e) ->
            if e.originalEvent.target.className.indexOf('leaflet-control-pan') > -1
                return
            else
                L.Draw.Polygon.prototype._onTouch.call(this, e)

        # setup an event listener to do things each time a vertex is drawn
        vertextListener = @map.on(L.Draw.Event.DRAWVERTEX, (one) =>
            if @current_tool.h?._markers?.length > 0
                # once we've laid the first marker, change the marker styling
                @current_tool.h.options.icon.options.iconSize.x = 8
                @current_tool.h.options.icon.options.iconSize.y = 8
                @current_tool.h.options.icon.options.className = defaultClasses
                # enable the delete point button and fire an event so we know that the polygon tool is now active
                @enableTooltipButton(@deletePointButton)
                @fire('mfdraw:polygon-tool-active')

                # if we have enough markers, enable the finish button
                if @current_tool.h._markers?.length >= 3
                    @enableTooltipButton(@finishButton)
        )

        @current_tool = {
            h: handler
            disable: () ->
                # call the handlers disable function
                @h.disable()
                # unregister the listeners we setup for the polygon handler
                @map?.off('mousedown')
                @map?.off(L.Draw.Event.DRAWVERTEX, vertextListener)
                # fire an event so that we know the polygon tool has become inactive
                self.fire('mfdraw:polygon-tool-inactive')
            # since handler is on the h property, we proxy this call to maintain a common interface with other tools
            # every other tool is able to be enabled with @current_tool.enable() while this one would ahve to be
            # enabled with @current_tool.h.enable() without this method
            enable: () ->
                handler.enable()
        }

        # enable the handler
        handler.enable()

    _polySelected: (e) =>
        if not e.layer.options.poly
            e.layer.options.poly =
                color: e.layer.options.color,
                drawError: {
                    color: e.layer.options.color,
                    timeout: 1000
                }

        e.layer.options.poly.allowIntersection = false

        handler = new L.Edit.Poly(e.layer)

        handler.enable()
        @fire 'select:poly-selected'

        # Disable the previous selection
        if @current_tool?.h? and @current_tool?.h?.disable?
            @current_tool.h.disable()

        current_tool = {
            h: null
            disable: () ->
                @h.disable()
            active: true
        }

        current_tool?.h = handler

        return current_tool
